import { usePushNotifications } from '../../infrastructure/push-notifications';

export const PushNotificationsInitializer = () => {
  usePushNotifications();
  return null;
};
